import React , {useRef,useState,useEffect,useLocation} from 'react';
import PackageList from '../../views/PartnerView/PackageList';
import PackageView from '../../views/PartnerView/PackageView';
import {useServiceContext} from '../../components/Context/ServiceContext';
import { useParams } from 'react-router-dom';
import EditPackage from '../../views/PartnerView/EditPackage';

const PartnerPackageListComponent = () => {
    const userType = localStorage.getItem('userType'); 
     const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 
    const { GetPackageByPartner, servicePackage, GetAllPackage } = useServiceContext();
      const { id,edit} = useParams();
    const getData = async () => {
        
        try {
            if (userType === 'ADMIN') {
                await GetAllPackage();
            } else {
                await GetPackageByPartner();

            }

                
                setLoading(false); // Set loading to false once data is fetched
  
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });

    return (
        <div>
            {id && edit ? (
                !loading && (edit === 'false' ? <PackageView /> : <EditPackage />)
            ) : (
                !loading && <PackageList />
            )}
        </div>
    );




};
export default PartnerPackageListComponent;